import { AlertTriangle, Loader2, ShieldCheck, Users, Wallet } from "lucide-react";
import { PRECO_MSG, brl } from "./modelos";

function Chip({ ativo, onClick, rotulo, total }) {
  return (
    <button type="button" onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium transition-colors ${
        ativo ? "border-[#25d366] bg-[#25d366] text-white" : "hover:bg-muted"}`}>
      {rotulo}
      <span className={`rounded-full px-1.5 text-xs tabular-nums ${ativo ? "bg-white/25" : "bg-muted text-muted-foreground"}`}>
        {total.toLocaleString("pt-BR")}
      </span>
    </button>
  );
}

/** Quantos clientes a campanha atinge, com base no público por grupo. */
// `selecionados`: null = Todos (e todos os grupos aparecem marcados);
// lista = só esses grupos (lista vazia = ninguém, e o disparo trava).
export function totalDoPublico(publico, selecionados) {
  const grupos = publico?.por_segmento || [];
  if (selecionados === null) return publico?.total_alvo || 0;
  return grupos.filter((g) => selecionados.includes(g.segmento)).reduce((s, g) => s + g.total, 0);
}

/**
 * Passo 2: quem vai receber. Grupos de clientes com a contagem de cada um;
 * nenhum marcado = todos que autorizaram WhatsApp. Mostra custo e saldo na hora.
 */
export default function PublicoWhatsApp({ publico, selecionados, setSelecionados, saldoCentavos }) {
  if (!publico) {
    return <p className="flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" /> Contando clientes…</p>;
  }
  const grupos = publico.por_segmento || [];
  const total = totalDoPublico(publico, selecionados);
  const semCusto = !!publico.sem_custo;
  const custo = total * (publico.preco_unitario ?? PRECO_MSG);
  const falta = !semCusto && saldoCentavos != null && custo * 100 > saldoCentavos;
  const todos = selecionados === null;
  const chaves = grupos.map((g) => g.segmento);
  // Com Todos marcado, clicar num grupo tira só ele; marcar o último que
  // faltava volta pra Todos.
  const alternar = (k) => {
    const base = todos ? chaves : selecionados;
    const prox = base.includes(k) ? base.filter((x) => x !== k) : [...base, k];
    setSelecionados(prox.length === chaves.length ? null : prox);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-2">
        <Chip ativo={todos} onClick={() => setSelecionados(todos ? [] : null)} rotulo="Todos" total={publico.total_alvo || 0} />
        {grupos.map((g) => (
          <Chip key={g.segmento} ativo={todos || selecionados.includes(g.segmento)} onClick={() => alternar(g.segmento)}
            rotulo={g.label} total={g.total} />
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="rounded-xl border bg-card p-4 sm:col-span-1">
          <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><Users className="h-3.5 w-3.5" /> Vão receber</p>
          <p className="mt-1 text-3xl font-bold tabular-nums">{total.toLocaleString("pt-BR")}</p>
          <p className="text-xs text-muted-foreground">cliente{total === 1 ? "" : "s"}</p>
        </div>
        <div className="rounded-xl border bg-card p-4">
          <p className="text-xs text-muted-foreground">Custo da campanha</p>
          <p className="mt-1 text-3xl font-bold tabular-nums">{semCusto ? "Sem custo" : brl(custo)}</p>
          <p className="text-xs text-muted-foreground">
            {semCusto ? "loja de teste: nada sai da carteira" : `R$ ${String(PRECO_MSG).replace(".", ",")} por mensagem`}
          </p>
        </div>
        <div className={`rounded-xl border p-4 ${falta ? "border-amber-500/60 bg-amber-500/5" : "bg-card"}`}>
          <p className="flex items-center gap-1.5 text-xs text-muted-foreground"><Wallet className="h-3.5 w-3.5" /> Saldo na carteira</p>
          <p className="mt-1 text-3xl font-bold tabular-nums">{saldoCentavos == null ? "—" : brl(saldoCentavos / 100)}</p>
          <p className={`text-xs ${falta ? "text-amber-600 font-medium" : "text-muted-foreground"}`}>
            {falta ? "Não dá pra essa campanha" : "a mesma do SMS e da Ligação"}
          </p>
        </div>
      </div>

      <p className="flex items-start gap-2 text-xs text-muted-foreground">
        <ShieldCheck className="h-4 w-4 shrink-0 text-[#25d366]" />
        Só recebe quem autorizou mensagens da loja no WhatsApp. Quem tocar em "Parar promoções" sai da lista na hora.
      </p>
      {publico.aviso_optin && (
        <p className="flex items-start gap-2 rounded-lg border border-amber-500/50 bg-amber-500/5 p-3 text-sm">
          <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500 mt-0.5" /> {publico.aviso_optin}
        </p>
      )}
    </div>
  );
}
